/**
 * @module 易速可花iOS相关模块路由
 */
export default [
  {
    path: '/yskh/mine/service',
    name: 'yskh_mine_service',
    component: () => import('@/pages/app/yskh-app/mine/service.vue'),
    meta: {
      title: '我的客服'
    }
  },
  {
    path: '/yskh/protocol/register',
    name: 'yskh_protocol_register',
    component: () => import('@/pages/app/yskh-app/protocol/register.vue'),
    meta: {
      title: '用户服务协议'
    }
  },
  {
    path: '/yskh/protocol/private',
    name: 'yskh_protocol_private',
    component: () => import('@/pages/app/yskh-app/protocol/private.vue'),
    meta: {
      title: '用户隐私保护政策'
    }
  }
]
